import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  settingsService,
  type CardTerminal,
  type CreateCardTerminalInput,
  type UpdateCardTerminalInput,
} from '@/services/settings.service';
import { settingsKeys } from '@/services/queryKeys';

export function useCardTerminals() {
  return useQuery<CardTerminal[]>({
    queryKey: settingsKeys.cardTerminals(),
    queryFn: () => settingsService.listCardTerminals(),
    retry: 0,
  });
}

export function useCreateCardTerminal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateCardTerminalInput) =>
      settingsService.createCardTerminal(body),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: settingsKeys.cardTerminals() }),
  });
}

export function useUpdateCardTerminal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateCardTerminalInput }) =>
      settingsService.updateCardTerminal(id, body),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: settingsKeys.cardTerminals() }),
  });
}

export function useDeleteCardTerminal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      settingsService.deleteCardTerminal(id),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: settingsKeys.cardTerminals() }),
  });
}

export function useSetDefaultCardTerminal() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      settingsService.setDefaultCardTerminal(id),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: settingsKeys.cardTerminals() }),
  });
}
